import api from './api'
import { Order, CreateOrderRequest, CreateOrderResponse } from '@/types'

export const orderService = {
  async createOrder(data: CreateOrderRequest): Promise<CreateOrderResponse> {
    const response = await api.post<CreateOrderResponse>('/orders/', data)
    return response.data
  },

  async getMyOrders(status?: string): Promise<Order[]> {
    const response = await api.get<Order[]>('/orders/', { params: { status } })
    return response.data
  },

  async getOrder(id: number): Promise<Order> {
    const response = await api.get<Order>(`/orders/${id}`)
    return response.data
  },

  async createPayment(
    order_id: number,
    payment_method: 'stripe' | 'paypal',
    return_url?: string
  ): Promise<{ client_secret?: string; approval_url?: string; payment_reference: string }> {
    const response = await api.post('/orders/payments/create', {
      order_id,
      payment_method,
      ...(return_url ? { return_url } : {}),
    })
    return response.data
  },

  async confirmPayment(payment_reference: string): Promise<{ message: string }> {
    const response = await api.post('/orders/payments/confirm', {
      payment_reference,
    })
    return response.data
  },

  async processTestPayment(order_id: number): Promise<{ message: string; payment_confirmed: boolean; order_id: number; order_number: string }> {
    const response = await api.post('/orders/payments/test', {
      order_id,
      payment_method: 'test',
    })
    return response.data
  },

  // Admin functions
  async getAllOrders(status?: string): Promise<Order[]> {
    const response = await api.get<Order[]>('/orders/admin/all', { params: { status } })
    return response.data
  },

  async updateOrderStatus(
    order_id: number,
    status: string,
    tracking_number?: string
  ): Promise<Order> {
    const response = await api.put<Order>(`/orders/${order_id}/status`, {
      status,
      tracking_number,
    })
    return response.data
  },

  async validateDiscount(code: string, productIds: number[]): Promise<{ valid: boolean; discount_type: string; discount_value: number }> {
    const response = await api.post('/products/validate-discount', { code, product_ids: productIds })
    return response.data
  },
}

// Alias for backwards compatibility
export const ordersService = orderService
